import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { Market } from 'frontend-utils/models';
import type MarketExecutiveSpiderDashboardController from 'lumen/controllers/market/executive/spider-dashboard';
// import type MarketRoute from 'lumen/routes/market';
import type { HotelAndMarketServiceWithMarket } from 'lumen/services/hotel-and-market';
import type { Transition } from 'lumen/services/transition';
import protectedRoute from 'lumen/utils/decorators/protected-route';
// import type { ModelFrom } from 'lumen/utils/routes';
import { EXECUTIVE_PATHS, resetIdQueryParams } from 'lumen/utils/spider';

// TODO: Stricten the return type for 'routes.market'
// type Model = ModelFrom<MarketRoute>;
type Model = Market;

type Params = {
  path: string;
};

type Path = (typeof EXECUTIVE_PATHS)[number];

@protectedRoute({ features: ['app.market.spider'] })
export default class MarketExecutiveSpiderDashboardRoute extends Route {
  queryParams = {
    view: {},
  };

  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithMarket;
  @service declare router: Services['router'];

  dashboard: string | undefined = undefined;
  lastMarketId: string | null = null;

  get extendedRouteName(): string {
    const { path } = this.paramsFor('market.executive.spider-dashboard') as {
      path: Path;
    };

    return this.fullRouteName.replace('spider-dashboard', path);
  }

  beforeModel(transition: Transition): void {
    const { path } = this.paramsFor('market.executive.spider-dashboard') as {
      path: Path;
    };

    if (!EXECUTIVE_PATHS.includes(path)) {
      this.router.replaceWith(
        'market.executive.spider-dashboard',
        EXECUTIVE_PATHS[0],
      );
    }

    if (
      this.lastMarketId !== this.hotelAndMarketService.market.id &&
      transition.from
    ) {
      const queryParams = resetIdQueryParams(transition);

      transition.abort();
      this.router.transitionTo(
        'market.executive.spider-dashboard',
        this.hotelAndMarketService.market.id,
        path,
        {
          queryParams,
        },
      );
    }

    this.lastMarketId = this.hotelAndMarketService.market.id;
  }

  model(params: Params): Model {
    /**
     * Stored `path` as a class property, because returning it from
     * the `model` hook will trigger a refresh when `path` changes.
     *
     * Spider handles changing routes. It will send a message to
     * update the URL.
     */
    this.dashboard = params.path;

    return this.modelFor('market') as Model;
  }

  setupController(controller: MarketExecutiveSpiderDashboardController): void {
    // @ts-expect-error: A spread argument must either have a tuple type or be passed to a rest parameter.
    // eslint-disable-next-line prefer-rest-params
    super.setupController(...arguments);

    controller.dashboard = this.dashboard!;
  }
}
